import fetchClient from './fetchClient';
import Cookies from "universal-cookie";

import { errorHandler } from "./utils";

const cookies = new Cookies(null, { path: "/" });


const config = () => {
    let token = localStorage.getItem("order-token");
    if (!token) token = cookies.get("order-token");

    return {
        headers: {
            Authorization: "Bearer " + token,
        },
    };
};

export const sendAutoOrder = async (data: any) => {
    const res: any = await fetchClient
        .post("/auto-orders/create", data, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const updateAutoOrder = async (orderId: string, data: any) => {
    const res: any = await fetchClient
        .put(`/auto-orders/order/${orderId}`, data, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const pingAutoOrderPage = async () => {
    const res: any = await fetchClient
        .get("/auto-orders/ping", config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const getOrdersFolders = async (year: string) => {
    const res: any = await fetchClient
        .get(`/auto-orders/my-orders/${year}/months`, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const getAutoOrderPage = async () => {
    const res: any = await fetchClient
        .get("/auto-orders", config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const getAlreadyOrderedProducts = async () => {
    const res: any = await fetchClient
        .get("/auto-orders/already-ordered", config())
        .catch(errorHandler);
    if (!res) return null;
    // Backend now returns { alreadyOrdered: [...], likedProducts: [...] }
    return res.data;
}

export const toggleLikeProduct = async (productId: string) => {
    const res: any = await fetchClient
        .post(`/auto-orders/like/${productId}`, {}, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
}

export const getStockAlertSubscriptions = async () => {
    const res: any = await fetchClient
        .get("/auto-orders/stock-alerts", config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
}

export const subscribeStockAlert = async (productId: string) => {
    const res: any = await fetchClient
        .post(`/auto-orders/stock-alerts/${productId}`, {}, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
}

export const unsubscribeStockAlert = async (productId: string) => {
    const res: any = await fetchClient
        .delete(`/auto-orders/stock-alerts/${productId}`, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
}

// Fire-and-forget: records that the customer opened a product's detail view.
export const trackProductView = async (productId: string) => {
    const res: any = await fetchClient
        .post(`/auto-orders/view/${productId}`, {}, config())
        .catch(() => null);
    if (!res) return null;
    return res.data;
}

export const getLastOrder = async () => {
    const res: any = await fetchClient
        .get("/auto-orders/last-order", config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
}

export const checkOrderForDate = async (date: string) => {
    const res: any = await fetchClient
        .get(`/auto-orders/check-date/${date}`, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
}

export const getAutoOrderConditions = async () => {
    const res: any = await fetchClient
        .get("/auto-orders/conditions", config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
}

export const updateCompanyInfo = async (data: any) => {
    const res: any = await fetchClient
        .put("/auto-orders/company-info", data, config())
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
}

export const getPaginatedAutoOrderProducts = async (
    page: number,
    limit: number,
    search?: string,
    category?: string,
    subCategory?: string,
    subFamily?: string
) => {
    const searchParam = search ? `&search=${encodeURIComponent(search)}` : '';
    const categoryParam = category ? `&category=${encodeURIComponent(category)}` : '';
    const subCategoryParam = subCategory ? `&subCategory=${encodeURIComponent(subCategory)}` : '';
    const subFamilyParam = subFamily ? `&subFamily=${encodeURIComponent(subFamily)}` : '';
    const res: any = await fetchClient
        .get(`/auto-orders?limit=${limit}&page=${page}${searchParam}${categoryParam}${subCategoryParam}${subFamilyParam}`, config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const getMyAutoOrdersPerMonth= async (
    month: string,
    year: string,
) => {
    const res: any = await fetchClient
        .get(`/auto-orders/my-orders/${month}/${year}`, config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const getMyInvoicesPerMonth = async (month: string, year: string) => {
    const res: any = await fetchClient
        .get(`/auto-orders/invoices/${month}/${year}`, config())
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return res.data;
};

export const getDeliveryNote = async (id: string) => {
    const fileConfig: any = {
        headers: {
            Authorization: config().headers.Authorization,
        },
        responseType: "arraybuffer",
    };
    const res = await fetchClient
        .get(`/auto-orders/delivery-note/${id}`, fileConfig)
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return new Blob([res.data], { type: "application/pdf" });
};

export const getAutoOrdersInvoice = async (id: string) => {
    const fileConfig: any = {
        headers: {
            Authorization: config().headers.Authorization,
        },
        responseType: "arraybuffer",
    };
    const res = await fetchClient
        .get(`/auto-orders/invoice/${id}`, fileConfig)
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return new Blob([res.data], { type: "application/pdf" });
};

export const getAnnouncementPdf = async () => {
    const fileConfig: any = {
        headers: {
            Authorization: config().headers.Authorization,
        },
        responseType: "arraybuffer",
    };
    const res = await fetchClient
        .get(`/auto-orders/announcement-pdf`, fileConfig)
        .catch((err) => {
            return null;
        });
    if (!res) return null;
    return new Blob([res.data], { type: "application/pdf" });
};

export const trackAnnouncementPdfViewed = async () => {
    const res: any = await fetchClient
        .post(`/auto-orders/announcement-pdf/viewed`, {}, config())
        .catch(() => null);
    return res;
};

export const loginOrder = async (data: any) => {
    const res: any = await fetchClient
        .post("/auto-orders/login", data)
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

// Public lookup: figure out which company a visitor landed for when the URL
// carries no ?supplier=, from either a personalized slug (/c/<slug>) or the
// hostname of document.referrer (matched against each company's own website).
export const resolveSupplier = async (params: { slug?: string; origin?: string }) => {
    const query = new URLSearchParams();
    if (params.slug) query.set('slug', params.slug);
    if (params.origin) query.set('origin', params.origin);

    const res: any = await fetchClient
        .get(`/auto-orders/resolve-supplier?${query.toString()}`)
        .catch(() => null);
    if (!res) return null;
    return res.data;
};

// Public lead form: visitor with no account asks to be recontacted about the
// catalog. Never grants shop access - just creates a prospect in the CRM.
export const sendCatalogInterest = async (data: any) => {
    const res: any = await fetchClient
        .post("/auto-orders/prospect-interest", data)
        .catch(errorHandler);
    if (!res) return null;
    return res.data;
};

export const verifyLoginOrder = async (data: any) => {
    const res: any = await fetchClient
        .post("/auto-orders/verify", data)
        .catch((e) => {
            console.log(e);
        });
    if (!res) return null;
    return res.data;
};
